import React from 'react';

export function StaffAccessNotice({ checking = false }: { checking?: boolean }) {
  return <div className="mx-auto max-w-7xl space-y-3 px-4 py-6 text-sm">
    {checking ? <p role="status">Checking staff access…</p>
      : <><p role="alert" data-support-code="authorization">Your signed-in account or staff access changed. This staff page has been closed.</p>
        <a className="text-blue-700 underline" href="/" onClick={() => {
          localStorage.removeItem(process.env.REACT_APP_ADMIN_STORAGE_KEY || 'admin-context');
        }}>Continue with current account</a></>}
  </div>;
}
